module.exports = __webpack_public_path__ + "static/media/select-user.8ec95710.svg";